/* eslint-disable camelcase */
import TransportationClient from '@/api/TransportationClient';

const defaultState = {
  vehicleInfo: {
    vin: '',
    make: '',
    model: '',
    year: '',
    weight: '',
    trim: '',
    class: '',
    active_request_associated: false,
  },
};

const mutations = {
  setVehicleInfo(state, vehicleInfo) {
    state.vehicleInfo = vehicleInfo;
  },
  resetVinState(state) {
    // Reset the entire state object
    Object.assign(state, defaultState);
  },
};

const actions = {
  async decodeVin({ rootGetters, commit }, vin) {
    const api = new TransportationClient(rootGetters.currentUser);

    // make api call here to validate VIN
    const { data } = await api.getDecodedVin(vin);

    commit('setVehicleInfo', data.data);

    return data.data;
  },
  resetVinState({ commit }) {
    commit('resetVinState');
  },
};

const getters = {
  getVehicleInfo: (state) => () => state.vehicleInfo,
};

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
};
